<template>
  <div id="app-download-guide-view">
    <div class="app-download-guide-title-wrapper">
      <div class="app-download-guide-title">アプリをご利用ください</div>
    </div>
    <div class="app-download-guide-message-wrapper">
      <div class="app-download-guide-message-1">
        あなたの肌状態にあわせて使い方を提案してくれるアプリ
      </div>
      <div class="app-download-guide-message-2">with Panasonic Beauty</div>
    </div>
    <div class="app-download-guide-img-wrapper">
      <img
        src="../assets/images/app_cycle.png"
        class="app-download-guide-img"
        alt="app_cycle"
      />
    </div>

    <div class="app-download-guide-point-message-wrapper">
      <div class="app-download-guide-point-message-container">
        <div class="app-download-guide-point-message">
          ・機器をお持ちでない方も、一部の機能をご利用いただけます
        </div>
      </div>
    </div>

    <button
      type="button"
      class="app-download-guide-install-button"
      @click="goToAppStore()"
    >
      アプリをインストール
    </button>
    <button
      type="button"
      class="app-download-guide-not-yet-button"
      @click="goToProductPage()"
    >
      今はしない
    </button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      appInstallUrl: "https://itunes.apple.com/jp/app/id6477898891?mt=8",
      productPageUrl: "https://panasonic.jp/face/",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("android") > -1) {
      this.appInstallUrl =
        "https://play.google.com/store/apps/details?id=com.panasonic.jp.las.facecare";
    }
  },
  destroyed() {},
  methods: {
    goToAppStore() {
      window.location.href = this.appInstallUrl;
    },
    goToProductPage() {
      window.location.href = this.productPageUrl;
    },
  },
};
</script>

<style>
#app-download-guide-view {
  /* 画面全体を覆うようにレイアウトを設定 */
  margin: 0px;
  padding: 0px;
  width: 100vw;
  min-height: 100svh;
  position: relative;
}

.app-download-guide-title-wrapper {
  height: 26px;
  width: 100%;
  position: absolute;
  top: 32px;
}

.app-download-guide-title {
  height: 100%;
  text-align: center;
  font: normal normal normal 18px/26px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;
}

.app-download-guide-message-wrapper {
  height: 60px;
  width: 100%;
  position: absolute;
  top: 80px;

  /* 子要素を縦方向に配置 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app-download-guide-message-1 {
  text-align: center;
  font: normal normal normal 12px/32px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.app-download-guide-message-2 {
  text-align: center;
  font: normal normal 300 28px/32px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.app-download-guide-img-wrapper {
  width: 326px;
  height: 268px;
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translate(-50%, 0%);
}
.app-download-guide-img {
  height: 100%;
  width: 100%;
  /* アスペクト比を維持したまま拡大縮小 */
  object-fit: contain;
}

.app-download-guide-point-message-wrapper {
  height: 81px;
  width: 80%;
  min-width: 327px;
  position: absolute;
  top: 434px;
  left: 50%;
  transform: translate(-50%, 0%);
}

.app-download-guide-point-message-container {
  height: 100%;
  width: 100%;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 12px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.app-download-guide-point-message {
  text-align: left;
  padding-right: 16px;
  padding-left: 16px;
  font: normal normal 500 12px/20px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000de;
  opacity: 1;
}

.app-download-guide-install-button {
  /* 表示位置 */
  position: absolute;
  top: 531px;
  left: 50%;
  transform: translate(-50%, 0%);

  /* ボタン */
  min-width: 343px;
  width: 80%;
  height: 52px;
  background: #000000 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  opacity: 0.9;

  /* テキスト */
  text-align: center;
  font: normal normal normal 15px/20px Noto Sans JP;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

.app-download-guide-not-yet-button {
  /* 表示位置 */
  position: absolute;
  top: 613px;
  left: 50%;
  transform: translate(-50%, 0%);

  /* ボタン */
  width: auto;
  height: 24px;
  background: none;
  border: none;

  /* テキスト */
  text-align: center;
  text-decoration: underline;
  font: normal normal normal 16px/24px Noto Sans JP;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
}
</style>
